// Detecta números de teléfono escritos en texto libre (es-AR).
// Réplica de la detección de puenteos de estudi-bot y de la validación que hace
// el back en PhoneNumberDetector. Contempla tres formatos:
//   1. Internacional:      +54 9 221 5688-201
//   2. Prefijo 0 argentino: 0221-568-8201 / 011 4567 8901
//   3. Dígitos sueltos:     2215688201 (entre 8 y 12 dígitos)
// Se evita el lookbehind (?<!\d) por compatibilidad con navegadores viejos: el
// borde previo se resuelve con (?:^|\D).
const PHONE_REGEX = new RegExp(
  [
    '\\+\\d{1,3}[\\s-]?(?:\\(?\\d{1,4}\\)?[\\s-]?)?\\d{3,5}[\\s-]?\\d{3,5}(?:[\\s-]?\\d{1,4})?',
    '0\\d{2,4}[\\s-]\\d{3,5}[\\s-]\\d{3,5}',
    '(?:^|\\D)\\d{8,12}(?!\\d)'
  ].join('|')
);

// Los identificadores dentro de links (ids de videollamadas, usuarios de redes)
// no son teléfonos, así que se sacan antes de buscar.
const URL_REGEX = /https?:\/\/\S+/g;

export const PHONE_NUMBER_IN_DESCRIPTION_MESSAGE =
  'No se pueden incluir números de teléfono en las descripciones. El contacto con tus alumnos se coordina siempre a través de estudi.';

export const containsPhoneNumber = (text?: string | null): boolean => {
  if (!text) {
    return false;
  }

  return PHONE_REGEX.test(text.replace(URL_REGEX, ' '));
};
